import { Component } from '@theme/component';

class ProductCardShowcase extends Component {
  /** @type {HTMLElement[]} */
  variants = [];

  /** @type {HTMLElement | null} */
  wrapper = null;

  /** @type {HTMLElement | null} */
  variantPicker = null;

  connectedCallback() {
    super.connectedCallback();

    this.initElements();
    this.initVariants();

    if (!this.variantPicker || !this.variants.length) return;

    this.initVariantChooser();
    this.initScrollSync();
  }

  /**
   * Cache DOM elements
   */
  initElements() {
    this.wrapper = this.querySelector('.product-card-showcase__wrapper');

    const showcase = this.closest('.product-showcase-content');
    const pickerEl = showcase?.querySelector('.product-card-showcase__swatches-picker');

    this.variantPicker = pickerEl ? document.getElementById(pickerEl.id) : null;
  }

  /**
   * Collect variant elements
   */
  initVariants() {
    if (!this.wrapper) return;

    this.variants = Array.from(this.wrapper.children).filter((el) => el instanceof HTMLElement);
  }

  /**
   * Build swatches UI
   */
  initVariantChooser() {
    let defaultIndex = 0;

    const subsection = document.createElement('div');
    subsection.id = `picker-subsection__${this.dataset.id}`;
    subsection.classList.add('picker-subsection');

    this.variants.forEach((variant, index) => {
      const variantId = `variant-swatch__${this.dataset.id}__${index}`;
      variant.id = variantId;

      const swatch = this.createSwatch(variant, variantId);

      if (variant.dataset.isDefaultOption && parseInt(variant.dataset.isDefaultOption)) {
        defaultIndex = index;
      }

      subsection.appendChild(swatch);
    });

    this.variantPicker.appendChild(subsection);

    // Default selection
    this.selectVariant(this.dataset.id, this.variants[defaultIndex].id);
  }

  createSwatch(variant, variantId) {
    const swatch = document.createElement('div');
    swatch.classList.add('swatches-picker-item');
    swatch.dataset.swatchId = variantId;

    swatch.style.setProperty('--swatch-bg-color', variant.dataset.colorCode || '#fff');

    const pill = document.createElement('button');
    pill.classList.add('swatches-picker-item__pill');

    const label = document.createElement('div');
    label.classList.add('swatches-picker-item__label');
    label.innerText = variant.dataset.colorLabel || ' ';

    swatch.appendChild(pill);
    swatch.appendChild(label);

    swatch.addEventListener('click', () => {
      this.selectVariant(this.dataset.id, variantId);
    });

    return swatch;
  }

  initScrollSync() {
    document.addEventListener('DOMContentLoaded', () => {
      const container = document.querySelector('.products-grid .group-block-content');
      if (!container || !this.variantPicker) return;

      const products = container.querySelectorAll('product-card-showcase');
      const pickers = document.querySelectorAll(`#${this.variantPicker.id} .picker-subsection`);

      if (!products.length || !pickers.length) return;

      const updateActivePicker = () => {
        let closestIndex = 0;
        let closestOffset = Infinity;

        products.forEach((el, index) => {
          const offset = Math.abs(el.getBoundingClientRect().left);

          if (offset < closestOffset) {
            closestOffset = offset;
            closestIndex = index;
          }
        });

        pickers.forEach((p, i) => {
          p.classList.toggle('active', i === closestIndex);
        });
      };

      container.addEventListener('scroll', () => {
        requestAnimationFrame(updateActivePicker);
      });

      updateActivePicker();
    });
  }

  /**
   * Handle variant selection
   */
  selectVariant(sectionId, id) {
    // Clear variants
    this.variants.forEach((v) => v.classList.remove('selected'));

    // Clear swatches
    const swatches = this.variantPicker?.querySelectorAll(`#picker-subsection__${sectionId} .swatches-picker-item`);

    swatches?.forEach((s) => s.classList.remove('selected'));

    // Activate variant
    const selectedVariant = this.variants.find((v) => v.id === id);
    selectedVariant?.classList.add('selected');

    // Activate swatch
    const selectedSwatch = this.variantPicker?.querySelector(
      `#picker-subsection__${sectionId} [data-swatch-id="${id}"]`,
    );

    selectedSwatch?.classList.add('selected');
  }
}

if (!customElements.get('product-card-showcase')) {
  customElements.define('product-card-showcase', ProductCardShowcase);
}
